import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { contractsAPI } from '../../services/api';

export const fetchContracts = createAsyncThunk('contracts/fetchAll', async (params, { rejectWithValue }) => {
  try { const res = await contractsAPI.list(params); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to fetch contracts'); }
});

export const fetchContract = createAsyncThunk('contracts/fetchOne', async (id, { rejectWithValue }) => {
  try { const res = await contractsAPI.get(id); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to fetch contract'); }
});

export const createContract = createAsyncThunk('contracts/create', async (data, { rejectWithValue }) => {
  try { const res = await contractsAPI.create(data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to create contract'); }
});

export const updateContract = createAsyncThunk('contracts/update', async ({ id, data }, { rejectWithValue }) => {
  try { const res = await contractsAPI.update(id, data); return res.data; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to update contract'); }
});

export const deleteContract = createAsyncThunk('contracts/delete', async (id, { rejectWithValue }) => {
  try { await contractsAPI.delete(id); return id; }
  catch (err) { return rejectWithValue(err.response?.data?.error || 'Failed to delete contract'); }
});

const contractsSlice = createSlice({
  name: 'contracts',
  initialState: {
    items: [], currentContract: null, versions: [], comments: [], obligations: [], approvalProgress: null, versionInfo: null,
    pagination: { page: 1, limit: 20, total: 0, pages: 0 },
    loading: false, error: null, filters: {},
  },
  reducers: {
    setFilters: (state, action) => { state.filters = action.payload; },
    clearCurrentContract: (state) => { state.currentContract = null; state.versions = []; state.comments = []; state.approvalProgress = null; state.versionInfo = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchContracts.pending, (state) => { state.loading = true; })
      .addCase(fetchContracts.fulfilled, (state, action) => {
        state.loading = false; state.items = action.payload.contracts; state.pagination = action.payload.pagination;
      })
      .addCase(fetchContracts.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(fetchContract.pending, (state) => { state.loading = true; })
      .addCase(fetchContract.fulfilled, (state, action) => {
        state.loading = false; state.currentContract = action.payload.contract;
        state.versions = action.payload.versions || []; state.comments = action.payload.comments || [];
        state.obligations = action.payload.obligations || [];
        state.approvalProgress = action.payload.approvalProgress || null;
        state.versionInfo = action.payload.versionInfo || null;
      })
      .addCase(fetchContract.rejected, (state, action) => { state.loading = false; state.error = action.payload; })
      .addCase(createContract.fulfilled, (state, action) => { state.items.unshift(action.payload.contract); })
      .addCase(updateContract.fulfilled, (state, action) => {
        const idx = state.items.findIndex(c => c._id === action.payload.contract._id);
        if (idx >= 0) state.items[idx] = action.payload.contract;
        if (state.currentContract?._id === action.payload.contract._id) state.currentContract = action.payload.contract;
      })
      .addCase(deleteContract.fulfilled, (state, action) => {
        state.items = state.items.filter(c => c._id !== action.payload);
      });
  },
});

export const { setFilters, clearCurrentContract } = contractsSlice.actions;
export default contractsSlice.reducer;
